import HowToHeader from '../HowToHeader';
import HowToStep from '../HowToStep';

// Images
import step1Img from './Step 1 Image.png';
import step2Img from './Step 2 Image.png';
import step3Img from './Step 3 Image.png';

// Header
const headerText = `Uploading Your Identity`;
const subtitleText = `We require you to upload a valid form of identification in order to proceed with obtaining a
                    registration number. Until you have done so, you will not be able to apply.`;

// Steps
const step1Text = `Click “Verify your identity” on your Account Dashboard.`;
const step2Text = `Upload your identification. This documentation must be current/unexpired and legible. The file
                    size of this document must be greater than 1 KB and less than 5 MB. Until proper documentation
                    is provided you will see this error message in the red box.`;
const step3Text = `Once you click “Submit” and the system recognizes that proper documentation and file size have
                    been used, you will see a green box appear that confirms the upload has been accepted.`;
const step4Text = `To verify that this step is complete, go back to your Account Dashboard. 
                    The “Verify your identity” box will no longer be present, confirming that this step requires no further action.`;

const UploadingYourIdentity = () => {
  return (
    <>
      <HowToHeader titleText={headerText} subtitleText={subtitleText} />
      <HowToStep stepNumber={1} content={step1Text} imgSrc={step1Img} />
      <HowToStep stepNumber={2} content={step2Text} imgSrc={step2Img} />
      <HowToStep stepNumber={3} content={step3Text} imgSrc={step3Img} />
      <HowToStep stepNumber={4} content={step4Text} />
    </>
  );
};

export default UploadingYourIdentity;
